/**
 * The structure keys the platform itself has to name, and which of them carry
 * per-instance feature toggles.
 *
 * Two structures keep a feature map an admin can edit: a space, through
 * `spaces.get` / `spaces.update`, and a story, through `stories.get` /
 * `stories.setFeatures`. Every other structure's features come from its
 * structure module's defaults and the silo's deployment defaults, so there is
 * nothing per-instance to show or write.
 *
 * `structureHasFeatureToggles` is the one place that distinction is decided.
 * The toggle UI asks it before it reads a structure module's `features` array,
 * so a structure cannot bring the UI back by declaring one — that array also
 * drives config assembly, and declaring it says nothing about who may edit it.
 */

/** The structure key a space is stored under. */
export const SPACE_STRUCTURE_KEY = 'question';

/** The structure key a story is stored under. */
export const STORY_STRUCTURE_KEY = 'article';

/** Whether this structure's instances carry a feature map an admin can edit. */
export function structureHasFeatureToggles(structureKey: string): boolean {
    return structureKey === SPACE_STRUCTURE_KEY || structureKey === STORY_STRUCTURE_KEY;
}
